React = require 'react/addons'
throttle = require 'lodash.throttle'

isMobile = false

module.exports =
  getInitialState: ->
    return {
      isMobile: isMobile
    }

  evaluateMobile: ->
    mobileCheck = document.getElementById 'mobile-check'

    unless mobileCheck
      mobileCheck = document.createElement 'div'
      mobileCheck.setAttribute 'id', 'mobile-check'
      document.body.appendChild mobileCheck

    if mobileCheck.offsetWidth > 0 and not(@state.isMobile)
      isMobile = true
      @setState { isMobile: true }
    else if mobileCheck.offsetWidth is 0 and @state.isMobile
      isMobile = false
      @setState { isMobile: false }

  componentWillMount: ->
    @evaluateMobile()

    window.addEventListener 'resize', @evaluateMobile

  componentWillUnmount: ->
    window.removeEventListener 'resize', @evaluateMobile



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/mixins/media-query.cjsx
 **/